<template>
  <div>
    <div class="pgment-5">
      <div class="func-menu" :style="'height:' + leftHt + 'px'">
        <!-- <div class="item-seek">
		      	   <el-input size="small" placeholder="请输入检索内容" suffix-icon="el-icon-search"></el-input>
		      </div> -->
        <el-tree
          class="filter-tree"
          :data="gmpTree"
          :props="gmpTreeProps"
          :filter-node-method="filterNode"
          @node-click="handleNodeClick"
          ref="tree2">
        </el-tree>
      </div>

      <div class="role-list">
        <!-- <el-scrollbar :style="'height:'+ leftHt + 'px'"> -->
        <div class="scroll-inner" style="margin-top: 15px">
          <el-button type="primary" size="mini" @click="initPublisherStartBatch(1)">初始化音像</el-button>
          <el-button type="primary" size="mini" @click="initPublisherStartBatch(2)">初始化电子</el-button>
          <el-button type="primary" size="mini" @click="recheckWorkerSum()">音像电子人员统计表计算</el-button>
          <el-button type="primary" size="mini" @click="fillReportForLxdz()">补充连续型出版物整改报告</el-button>
        </div>
        <div class="scroll-inner">
          <el-table
            :data="filterData(tabDat, seekStore.where).slice((currentPage - 1) * pageSize, currentPage * pageSize)"
            style="width: 100%">
            <el-table-column label="序号" align="center" width="90">
              <template slot-scope="scope">
                {{ scope.$index + 1 + (currentPage - 1) * pageSize }}
                <!-- <span>{{ scope.$index + 1 + 15*(seekStore.no - 1) }}</span> -->
              </template>
            </el-table-column>
            <el-table-column label="账号" width="200" prop="account"> </el-table-column>
            <el-table-column label="状态" align="center" width="150">
              <template slot-scope="scope">
                <span style="color: green" v-if="scope.row.isDeleted == 1">正常</span>
                <span style="color: red" v-if="scope.row.isDeleted != 1">已禁用</span>
              </template>
            </el-table-column>
            <el-table-column label="名称" width="200" prop="organizationName"> </el-table-column>
            <el-table-column :width="styleSet.edWidth" align="right">
              <template slot="header" slot-scope="scope">
                <el-input class="headSeek" v-model="seekStore.where" size="small" placeholder="输入关键字搜索" />
                <el-button class="newAdd" type="primary" size="mini" @click="userPocts({ type: 'show', code: 1 })"
                  >新增
                </el-button>
                <!-- <el-button class="newAdd" type="primary" size="mini" @click="dialogVisible = true">操作历史</el-button> -->
              </template>
              <template slot-scope="scope">
                <div class="btnGroup">
                  <el-button size="mini" type="danger" v-if="scope.row.isDeleted == 1" @click="setDeleted(scope.row, 2)"
                    >禁用</el-button
                  >
                  <el-button
                    size="mini"
                    type="primary"
                    v-if="scope.row.isDeleted != 1"
                    @click="setDeleted(scope.row, 1)"
                    >启用</el-button
                  >
                  <el-button size="mini" @click="userPocts({ type: 'show', code: 2, dats: scope.row })"
                    >修改信息</el-button
                  >
                  <el-button size="mini" type="warning" @click="rolePocts({ type: 'show', dats: scope.row })"
                    >分配权限
                  </el-button>
                  <el-button size="mini" type="primary" @click="rolePocts({ type: 'resetPwd', dats: scope.row })"
                    >重置密码
                  </el-button>
                  <el-button size="mini" type="danger" @click="userPocts({ type: 'remove', dats: scope.row })"
                    >删除账号
                  </el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <!-- </el-scrollbar> -->
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          background
          layout="total, prev, pager, next"
          :total="total"
          :page-size="pageSize"
          :page-sizes="sizesArray">
        </el-pagination>
        <!-- <div class="pg-figs">
	           	    <el-pagination
						v-if="tabPages > 1"
						layout="prev, pager, next"
						:current-page="seekStore.no"
						@current-change="pageChange"
						:page-count="tabPages">
					 </el-pagination>
	           </div> -->
      </div>

      <el-dialog :title="userPop.diaTitle" class="pgment-5-dag" :visible.sync="userPop.diaCtrls" width="450px" center>
        <el-row class="textRow">
          <el-col :span="5" class="ttName">
            <span>机构名称：</span>
          </el-col>
          <el-col :span="18">
            <span style="line-height: 26px; font-weight: bold">{{ userPop.organizationName }}</span>
          </el-col>
        </el-row>
        <el-row class="textRow">
          <el-col :span="5" class="ttName">
            <span>姓名：</span>
          </el-col>
          <el-col :span="18">
            <el-input size="small" v-model="userPop.uName" />
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="5" class="ttName">
            <span>手机：</span>
          </el-col>
          <el-col :span="18">
            <el-input size="small" v-model="userPop.uPhone" />
          </el-col>
        </el-row>

        <span slot="footer" class="dialog-footer">
          <el-button @click="userPocts({ type: 'cencel' })" size="small">取 消</el-button>
          <el-button class="inContent" type="primary" @click="userPocts({ type: 'sure' })" size="small"
            >确 定</el-button
          >
        </span>
      </el-dialog>

      <el-dialog title="权限配置" class="pgment-5-dag2" :visible.sync="rolePop.diaCtrls" width="540px" center>
        <el-row>
          <el-col :span="3" class="ttName">
            <span>角色：</span>
          </el-col>
          <el-col :span="21">
            <template>
              <el-checkbox-group class="checkGp" v-model="rolePop.chosenArrs" @change="userDefine">
                <el-checkbox v-for="role in rolePop.roleArrs" :label="role.id" :key="role.id"
                  >{{ role.name }}
                </el-checkbox>
              </el-checkbox-group>
            </template>
          </el-col>
        </el-row>
        <!-- <el-row class="dag2-row">
          <el-col :span="3" class="ttName">
            <span>权限：</span>
          </el-col>
          <el-col :span="21">
            <div class="dagInner">
              <el-scrollbar>
                <el-tree :data="enterTree" ref="tree" empty-text="" node-key="id" :check-strictly="true"
                  :show-checkbox="false" :props="enterTreeProps">
                </el-tree>
              </el-scrollbar>
            </div>
          </el-col>
        </el-row> -->

        <span slot="footer" class="dialog-footer">
          <el-button @click="rolePocts({ type: 'cencel' })" size="small">取 消</el-button>
          <el-button class="inContent" type="primary" @click="rolePocts({ type: 'sure' })" size="small"
            >确 定</el-button
          >
        </span>
      </el-dialog>
      <el-dialog title="操作历史" width="80%" :visible.sync="dialogVisible" center>
        <el-table :data="tableData" style="width: 100%">
          <el-table-column type="index" width="50" label="序号"> </el-table-column>
          <el-table-column prop="type" label="操作" width="180"> </el-table-column>
          <el-table-column prop="userAccount" label="账号名称"> </el-table-column>
          <el-table-column prop="content" label="操作内容">
            <template slot-scope="scope">
              <p v-if="scope.row.content === '暂无内容'">{{ scope.row.content }}</p>
              <p v-else v-for="(val, key) in scope.row.content">{{ key }}: {{ val }}</p>
            </template>
          </el-table-column>
          <el-table-column prop="createdAt" label="操作时间"> </el-table-column>
        </el-table>
        <el-pagination
          layout="prev, pager, next"
          :page-count="historytotalPages"
          @current-change="historyPageChange"
          :current-page="no">
        </el-pagination>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {
  getGmpTree, // zym.机构树形机构
  getUserList, // zym.查询用户列表
  getConfiged,
  getRoles,
  userConnectRole, // zym.保存分配的角色
  userCreate, // zym.新增、修改用户帐号
  setDeleted, // zym.设置启用、禁用
  userRemove,
  getUserRoles,
  userUpdate,
  UserAdminOperationList,
  initPublisherStartBatch, // zym.批量生成初始化数据 - 音像、电子
  recheckWorkerSum,
  fillReportForLxdz, // zym.补充连续型出版物整改报告
} from "@/api/pgMent/userMent";

import {
  resetPasswordFormAdmin, // zym.重置密码
} from "@/api/account";
import initPagin from "@/mixins/initPagin";
import _ from "lodash";

export default {
  mixins: [initPagin],
  data() {
    return {
      styleSet: {
        edWidth: 480,
      },
      leftHt: 0,
      muserId: "",
      // 机构树
      gmpTree: [],
      gmpTreeProps: {
        //  children: 'getCompanyPostModules',
        label: "name",
      },

      // 用列表默认缓存
      seekStore: {
        no: 1,
        size: 15,
        where: "",
        organizationId: "",
        id: "",
      },
      tabDat: [],
      tabPages: 0,

      // 新增、修改用户基础信息
      userPop: {
        diaCtrls: false,
        diaTitle: "",
        uName: "",
        uPhone: "",
        uId: "",
      },
      // 配置用户角色
      rolePop: {
        userId: "",
        diaCtrls: false,
        roleArrs: [],
        chosenArrs: [],
        tmpRole: {},
      },
      // 角色关联权限树
      enterTree: [],
      enterTreeProps: {
        children: "menuRuleModules",
        label: "name",
      },
      tableData: [],
      dialogVisible: false,
      no: 1,
      size: 20,
      historytotalPages: 0,
    };
  },
  watch: {
    "seekStore.where": function () {
      this.seekStore.no = 1;
      this.userList();
    },
  },
  methods: {
    setDeleted: function (dat, goStatus) {
      setDeleted({
        id: dat.id,
        goStatus: goStatus,
      }).then((response) => {
        console.log("response=", JSON.stringify(response));
        let tipCode = response.tipCode;
        let tipMessage = response.tipMessage || "操作失败";
        if (tipCode == "fail") {
          this.$message({
            showClose: true,
            message: tipMessage,
            type: "error",
          });
        } else {
          this.$message({
            showClose: true,
            message: tipMessage,
            type: "success",
          });
          this.$emit("go-frash");
        }
      });
    },
    // zym.补充连续型出版物整改报告
    fillReportForLxdz: function (type) {
      this.$confirm("是否确定补充连续型出版物整改报告？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          fillReportForLxdz({
            type: type,
          }).then((response) => {
            console.log("response=", JSON.stringify(response));
            let tipCode = response.tipCode;
            let tipMessage = response.tipMessage || "操作失败";
            if (tipCode == "fail") {
              this.$message({
                showClose: true,
                message: tipMessage,
                type: "error",
              });
            } else {
              this.$message({
                showClose: true,
                message: tipMessage,
                type: "success",
              });
            }
          });
        })
        .catch((error) => {});
    },
    // zym.同步音电年检数据
    initPublisherStartBatch: function (type) {
      this.$confirm("是否确定初始化流程？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          initPublisherStartBatch({
            type: type,
          }).then((response) => {
            console.log("response=", JSON.stringify(response));
            let tipCode = response.tipCode;
            let tipMessage = response.tipMessage || "操作失败";
            if (tipCode == "fail") {
              this.$message({
                showClose: true,
                message: tipMessage,
                type: "error",
              });
            } else {
              this.$message({
                showClose: true,
                message: tipMessage,
                type: "success",
              });
            }
          });
        })
        .catch((error) => {});
    },
    recheckWorkerSum: function () {
      recheckWorkerSum({}).then((response) => {
        console.log("response=", JSON.stringify(response));
        let tipCode = response.tipCode;
        let tipMessage = response.tipMessage || "操作失败";
        if (tipCode == "fail") {
          this.$message({
            showClose: true,
            message: tipMessage,
            type: "error",
          });
        }
      });
    },
    /*
     * 获取机构树
     */

    gmpTreeInit: function () {
      getGmpTree()
        .then((response) => {
          // let unFormate = response.getCompanyPostTreeModules;
          let unFormate = response.payload;
          this.gmpTree = unFormate;
          this.seekStore.organizationId = unFormate[0].id;
          this.seekStore.organizationName = unFormate[0].name;
          this.seekStore.no = 1;
          this.userList();
          this.muserId = unFormate[0].id;
          this.gmpRolesGet();
        })
        .catch((error) => {
          console.log(error);
        });
    },

    /*
     * 获取当前机构下用户列表 (列表刷新通用)
     */

    userList: function () {
      getUserList(this.seekStore)
        .then((response) => {
          // this.tabDat = response.userModules;
          this.tabDat = response.payload;
          // this.tabPages = response.totalPages;
          this.total = response.payload.length;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    /*
     * 新增、修改用户基础信息
     */

    userPocts: function ({ type, code, dats }) {
      if (type == "show") {
        if (code == 1) {
          this.userPop.diaTitle = "新增账号";
          this.userPop.uName = "";
          this.userPop.uPhone = "";
          this.userPop.uId = "";
          this.userPop.organizationName = this.seekStore.organizationName;
          this.userPop.organizationId = this.seekStore.organizationId;
        } else if (code == 2) {
          this.userPop.diaTitle = "修改账号信息";
          this.userPop.uName = dats.account;
          this.userPop.uPhone = dats.cellPhone;
          this.userPop.uId = dats.id;
          this.userPop.organizationName = dats.organizationName;
          this.userPop.organizationId = dats.organizationId;
        }
        this.userPop.diaCtrls = true;
      } else if (type == "cencel") {
        this.userPop.diaCtrls = false;
      } else if (type == "sure") {
        if (!this.userPop.uName) {
          this.$message.error("姓名必须填写");
        }
        // else if (!this.userPop.uPhone) {
        //   this.$message.error('手机号必须填写');
        // }
        // else {
        //   let pattern = /^1[3|4|5|7|8][0-9]{9}$/;
        //   if (pattern.test(this.userPop.uPhone)) {
        if (this.userPop.uId) {
          userCreate({
            account: this.userPop.uName,
            cellPhone: this.userPop.uPhone,
            id: this.userPop.uId,
            organizationId: this.seekStore.organizationId,
          }).then((response) => {
            let tipCode = response.tipCode;
            let tipMessage = response.message || "操作失败";
            if (tipCode == "fail") {
              this.$message({
                showClose: true,
                message: tipMessage,
                type: "error",
              });
            } else {
              this.$message.success("修改成功");
              this.$emit("go-frash");
            }
          });
        } else {
          userCreate({
            account: this.userPop.uName,
            cellPhone: this.userPop.uPhone,
            organizationId: this.seekStore.organizationId,
          }).then((response) => {
            let tipCode = response.tipCode;
            let tipMessage = response.message || "操作失败";
            if (tipCode == "fail") {
              this.$message({
                showClose: true,
                message: tipMessage,
                type: "error",
              });
            } else {
              this.$message.success("新增成功");
              this.$emit("go-frash");
            }
          });
        }
        //   } else {
        //     this.$message.error('手机号错误');
        //   }
        // }
      } else if (type == "remove") {
        this.$confirm('确定要删除账号"' + dats.account + '"吗？', "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            userRemove({
              id: dats.id,
            }).then((response) => {
              let tipCode = response.tipCode;
              let tipMessage = response.message || "操作失败";
              if (tipCode == "fail") {
                this.$message({
                  showClose: true,
                  message: tipMessage,
                  type: "error",
                });
              } else {
                this.$message({
                  showClose: true,
                  message: "删除成功！",
                  type: "success",
                });
                this.$emit("go-frash");
              }
            });
          })
          .catch((error) => {});
      }
    },
    /*
     * 用户角色配置
     */
    rolePocts: function ({ type, dats }) {
      if (type == "show") {
        this.rolePop.diaCtrls = true;
        this.rolePop.tempRole = dats;
        getUserRoles({
          userId: dats.id,
        }).then((response) => {
          console.log("response=", JSON.stringify(response));
          // let unFormate = response.userModule.postIds;
          // if (unFormate) {
          //   this.rolePop.chosenArrs = unFormate.split(",");
          // } else {
          //   this.rolePop.chosenArrs = [];
          // }
          this.rolePop.chosenArrs = response;
          this.userDefine();
        });
      } else if (type == "cencel") {
        this.rolePop.diaCtrls = false;
      } else if (type == "sure") {
        this.rolePop.tempRole.postIds = this.rolePop.chosenArrs;
        userConnectRole(this.rolePop.tempRole).then((response) => {
          let tipCode = response.tipCode;
          let tipMessage = response.message || "操作失败";
          if (tipCode == "fail") {
            this.$message({
              showClose: true,
              message: tipMessage,
              type: "error",
            });
          } else {
            this.$message({
              showClose: true,
              message: "配置成功！",
              type: "success",
            });
            this.rolePop.diaCtrls = false;
          }
        });
      } else if (type == "resetPwd") {
        this.$confirm("确认要重置 “" + dats.account + "” 的密码吗？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          // console.warn('resetPasswordFormAdmin: ', dats)
          resetPasswordFormAdmin({
            id: dats.id,
          }).then((response) => {
            let tipCode = response.tipCode;
            let tipMessage = response.message || "操作失败";
            if (tipCode == "fail") {
              this.$message({
                showClose: true,
                message: tipMessage,
                type: "error",
              });
            } else {
              this.$message.success({ message: tipMessage });
            }
          });
        });
      }
    },

    /*
     * 根据角色获取权限
     */
    userDefine: function () {
      // if (this.rolePop.chosenArrs.length > 0) {
      //   getConfiged({
      //     postIds: this.rolePop.chosenArrs
      //   }).then(response => {
      //     this.enterTree = response.menuRuleTreeModules;
      //   }).catch(error => {
      //     console.log(error);
      //   })
      // } else {
      //   this.enterTree = [];
      // }
    },

    /*
     * 机构检索
     */

    filterNode: function (value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },

    /*
     * 机构变动
     */

    handleNodeClick: function (data) {
      if (this.seekStore.organizationId != data.id) {
        this.seekStore.no = 1;
        this.seekStore.organizationId = data.id;
        this.seekStore.organizationName = data.name;
        this.userList();
        this.gmpRolesGet();
      }
    },

    /*
     * 机构角色
     */
    gmpRolesGet: function () {
      getRoles({
        id: this.muserId,
        type: 4,
      }).then((response) => {
        // let newArr = [];
        this.rolePop.roleArrs = response;
      });
    },

    /*
     * 分页
     */

    pageChange: function (inx) {
      this.seekStore.no = inx;
      this.userList();
    },
    /*
     * 新增管理员对用户的操作历史记录
     */
    getHistoryList: function () {
      UserAdminOperationList({
        no: this.no,
        size: this.size,
      }).then((response) => {
        // console.warn('getHistoryList: ', response)
        this.historytotalPages = response.totalPages;
        this.tableData = response.adminOperations;
        for (const item of this.tableData) {
          if (item.type == 1) {
            item.type = "新增";
          } else if (item.type == 2) {
            item.type = "修改信息";
          } else if (item.type == 3) {
            item.type = "分配权限";
          } else if (item.type == 4) {
            item.type = "重置密码";
          } else if (item.type == 5) {
            item.type = "删除";
          }

          // 如果是json 则转成json
          if (this.isJSON(item.content)) {
            item.content = JSON.parse(item.content.trim());
          } else {
            item.content = "暂无内容";
          }
        }
      });
    },
    // 判断字符串是不是json格式
    isJSON(str) {
      if (typeof str == "string") {
        try {
          let obj = JSON.parse(str);
          if (typeof obj == "object" && obj) {
            return true;
          } else {
            return false;
          }
        } catch (e) {
          return false;
        }
      }
    },
    /*
     * 新增管理员对用户的操作历史记录的翻页
     */
    historyPageChange: function (inx) {
      this.no = inx;
      this.getHistoryList();
    },
    filterData: function (data, text) {
      console.debug("filterData: ", text);
      if (!text || text.trim() === "") return data;
      text = text.toLowerCase();
      return _.filter(data, (x) => {
        return (x.organizationName && x.organizationName.includes(text)) || (x.account && x.account.includes(text));
      });
    },
  },

  beforeMount: function () {
    this.gmpTreeInit();
  },

  created: function () {
    this.getHistoryList();
    let bdHt = document.body.clientHeight;
    let wsHt = document.documentElement.clientHeight;
    // if(bdHt > wsHt){
    // 		this.leftHt = bdHt - 140;
    // }else{
    // 		this.leftHt = wsHt - 140;
    // }

    this.leftHt = wsHt - 140;

    let scWidth = document.documentElement.clientWidth;
    if (scWidth <= 1280) {
      this.styleSet.edWidth = 420;
    }
  },
};
</script>

<style>
.pgment-5 {
  padding-left: 1px;
  position: relative;
  /*padding: 20px 30px;*/
}

.pgment-5 .btnGroup .el-button + .el-button {
  margin-left: 0px;
}

/* 角色树 */

.pgment-5 .func-menu {
  width: 240px;
  /* border-right: 1px solid #ebeef5; */
  position: absolute;
  left: 1px;
  top: 0px;
}

.pgment-5 .filter-tree {
  margin: 12px 6px;
}

.pgment-5 .item-seek {
  padding: 15px 9px;
  border-bottom: 1px solid #ebeef5;
}

.pgment-5 .treeitem {
  padding: 6px 0px;
}

/* 角色列表 */

.pgment-5 .role-list {
  margin-left: 240px;
  border-left: 1px solid #ebeef5;
  padding: 0px 20px;
  position: relative;
}

.pgment-5 .role-list .headSeek {
  width: 360px;
  vertical-align: middle;
  display: inline-block;
}

.pgment-5 .role-list .newAdd {
  width: 90px;
  vertical-align: middle;
  display: inline-block;
}

.pgment-5 .el-scrollbar__wrap {
  overflow-x: hidden;
}

.pgment-5 .el-tree-node .el-tree-node__content {
  padding: 3px 0px 5px;
}

/* 创建弹出层 */

.pgment-5-dag .btncage {
  text-align: center;
}

.pgment-5-dag .el-button {
  /*width: 90px;*/
}

.pgment-5-dag .el-dialog__footer {
  padding-bottom: 24px;
}

.pgment-5-dag .textRow {
  margin-bottom: 24px;
}

.pgment-5-dag .ttName {
  text-align: right;
  line-height: 26px;
}

.pgment-5-dag .ttName span {
  margin-right: 12px;
  vertical-align: middle;
}

/* 配置弹出层 */

.pgment-5-dag2 .dagInner .el-scrollbar__wrap {
  max-height: 450px;
  padding: 20px 0px;
  overflow-x: hidden;
}

.pgment-5-dag2 .ttName span {
  margin-left: 9px;
}

.pgment-5-dag2 .checkGp .el-checkbox {
  margin-right: 24px;
  margin-left: 0px;
  margin-bottom: 9px;
}

.pgment-5-dag2 .dag2-row .ttName {
  padding-top: 24px;
}

/* 分页 */

.pgment-5 .pg-figs {
  text-align: center;
  margin-top: 30px;
  margin-bottom: 30px;
}
</style>

<style>
@media screen and (max-width: 1280px) {
  .pgment-5 .role-list {
    margin-left: 210px;
  }

  .pgment-5 .role-list .headSeek {
    width: 300px;
    vertical-align: middle;
    display: inline-block;
  }

  .pgment-5 .func-menu {
    width: 210px;
  }
}
</style>



// WEBPACK FOOTER //
// userMent.vue?146b3c80